module.exports = __webpack_public_path__ + "static/Dierbergs-397af14faecdd3913fbca27c3d797086.png";